module.exports = __webpack_public_path__ + "onboarding-releases.cd957cfdaeea3ed82965bf11ac4d1888.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-releases.svg
// module id = 2729789388511533
// module chunks = 1